
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Calque 1","viewBox":"0 0 1440 1024"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M-.25 703.82v174c485.562 11.57 958.748 17.11 1256.162 14.74L459.734 788.212c-184.748-4.371-251.9-88.289-459.984-84.392z","fill":"#e5eecf"}}),_c('path',{attrs:{"d":"M8.89 863.33c-3.28.33-3.08 1.9-8.89 2.24v158.59l1440 .11V858.84C2022.436 615.27 71.443 841.635 8.89 863.33z","fill":"#c5e567"}})])
          )
        }
      }
    